export default __webpack_public_path__ + "static/media/error.312678b3.svg";